package guide.kuki.app.engine

import kotlinx.browser.window
import kotlinx.coroutines.await
import org.khronos.webgl.Int8Array
import org.khronos.webgl.get

internal actual suspend fun platformFetchBytes(url: String): ByteArray? {
    return try {
        val response = window.fetch(url).await()
        if (!response.ok) return null
        val buffer = response.arrayBuffer().await()
        val view = Int8Array(buffer)
        ByteArray(view.length) { view[it] }
    } catch (_: Throwable) {
        null
    }
}
